import React from "react";
import { useFormContext, useController } from "react-hook-form";
import { Dropdown, IDropdownOption } from "./Dropdown";
import { InputErrorMessage } from "components/atoms";

export interface PaziaDropdownProps {
  name: string;
  options: IDropdownOption[];
  label?: string;
  className?: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

export const PaziaDropdown = ({
  label,
  name,
  options,
  className,
  required,
  placeholder,
  disabled,
}: PaziaDropdownProps): JSX.Element => {
  const { control } = useFormContext();

  const { field } = useController({
    name,
    control,
    rules: { required },
  });

  const onChangeHandler = (value: string | number) => {
    field.onChange(value);
  };

  return (
    <>
      <Dropdown
        label={label}
        required={required}
        options={options}
        className={className}
        onChange={onChangeHandler}
        value={field.value}
        name={field.name}
        placeholder={placeholder}
        disabled={disabled}
      />
      <InputErrorMessage name={name} />
    </>
  );
};
